import { Flex, Skeleton } from "antd";
import { groupBy } from "lodash-es";

import styles from "./ReportsPage.module.scss";

import issuesSummaryImg from "../../assets/img/issuesSummaryImg.png";
import milestonesSummaryImg from "../../assets/img/milestonesSummaryImg.png";
import projectSummaryImg from "../../assets/img/projectSummaryImg.png";
import { Description } from "../../components/Description";
import { ReportsItem, ReportsItemPlaceholder } from "../../components/Reports/components/ReportsItem";
import { useCurrenSyncLogs } from "../../hooks/useCurrenSyncLogs";

export const ReportsPage = () => {
  const { data, isLoading } = useCurrenSyncLogs();

  const reportImages = {
    ProjectSummary: projectSummaryImg,
    IssueSummary: issuesSummaryImg,
    MilestoneSummary: milestonesSummaryImg,
  };

  // filter out items without adapterIdentifier
  const filteredData = data?.filter((item) => item.adapterIdentifier);
  // group reports by adapterIdentifier
  const groupedByAdapter = Object.entries(groupBy(filteredData, (item) => item.adapterIdentifier));

  return (
    <Flex vertical className={styles.root} gap={36}>
      {isLoading && (
        <Flex vertical className={styles.skeletonWrapper} gap={16}>
          <Skeleton.Input active size="large" className={styles.skeletonInput} />
          <Flex className={styles.reportsList} gap={24}>
            {Array.from({ length: 3 }).map((_, index) => (
              <ReportsItemPlaceholder key={index} />
            ))}
          </Flex>
        </Flex>
      )}
      {!isLoading && groupedByAdapter.map(([adapterId, adapterItems]) => {
        return (
          <Flex vertical key={adapterId} className={styles.adapterGroup} gap={16}>
            <Description theme="t1" className={styles.adapterTitle}>{adapterId}</Description>
            <Flex className={styles.adapterItems} gap={24}>
              {adapterItems.map((report) => (
                <ReportsItem
                  key={report.entityIdentifier}
                  id={report.entityIdentifier}
                  fileName={report.entityIdentifier}
                  title={report.entityIdentifierDisplayName}
                  type={report.entityIdentifier}
                  report={
                    reportImages[report.entityIdentifier as keyof typeof reportImages]
                  }
                  isDisable={!report.entityIdentifier}
                />
              ))}
            </Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};
